import React, { Component } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { Box, Link } from '@mui/material';
import ThemeProvider from 'ui-lib/ThemeProvider';
import CrashError from '../../../submodules/web-shared/elements/ErrorBoundary/CrashError';
import ErrorPage from '.';

interface Props {
  children: React.ReactNode;
  errorMessage?: React.ReactNode | (({ error }: { error: Error }) => React.ReactNode);
  enableCrashLogs?: boolean;
  mixedTheme: boolean;
}

interface State {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, errorInfo: null };
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {

    if (process.env.DATADOG_APP_ID) {
      datadogRum.addError(
        this.props.enableCrashLogs
          ? new CrashError(error)
          : error
      );
    }
    this.setState({ error, errorInfo });
  }
  render() {
    const { errorInfo, error } = this.state;
    const { errorMessage } = this.props;

    const renderMessage = () => {
      if (error?.name === 'ChunkLoadError' || error?.message?.includes('Loading CSS chunk')) {
        return <Box>
          This application has been updated, please
          <Link onClick={() => window.location.reload()}> refresh your browser </Link>
          to see the latest content.
        </Box>;
      }

      if (typeof errorMessage === 'function') {
        return errorMessage({ error: error! });
      }

      return errorMessage;
    };

    if (errorInfo) {

      if (this.props.mixedTheme) {
        return <ThemeProvider>
          <ErrorPage message={renderMessage()} />
        </ThemeProvider>;
      }

      return <ErrorPage message={renderMessage()} />;
    }

    return this.props.children;
  }
}
